import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';
import { of } from "rxjs/observable/of";

import { environment } from '../../environments/environment';
import { AuthenticationService } from '.';
import * as FileSaver from 'file-saver';

@Injectable()
export class StorageService {

    private sorterURL = environment.storageURL + 'sorterConfig';
    private storageURL = environment.storageURL + 'warehouse';
    private containerURL = environment.storageURL + 'container';
    private exceptionURL = environment.storageURL + 'exception';
    private readerURL = environment.readerURL + 'data';
    containerNameBarcodeMaxLength: number = 10;

    userName: String;

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService,
        private injector: Injector) {
    }

    recalculate() {
        let filter: string = '/recalculate';
        return this.http.put(this.sorterURL + filter , {},{
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return {};
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not recalculate"));
        });
    }

    getSorterContainerConfigList(storage: string, sorterName: string) {
        let filter: string = '/sorterContainerConfigList' + '?storage=' + storage + '&sorterName=' + sorterName
        return this.http.get(this.sorterURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get sorter container config list"));
        });
    }

    getSorterContainerConfig(containerName: string, channel: string, storage: string, sorterName: string) {
        let filter: string = '/sorterContainerConfig' + '?containerName=' + containerName + '&channel=' + channel + '&storage=' + storage + '&sorterName=' + sorterName
        return this.http.get(this.sorterURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get sorter container config item"));
        });
    }

    updateSorterContainerConfig(storage: string, sorterName: string, channel: string, newContainerName: string){
        let filter: string = '/updateSorterContainerConfig' + '?storage=' + storage + '&sorterName=' + sorterName + '&channel=' + channel + '&newContainerName=' + newContainerName;
        return this.http.put(this.sorterURL + filter, {}, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not update Sorter Container config"));
        });  
    }

    getSorterConfigList() {
        let filter: string = '/sorterConfigList';
        return this.http.get(this.sorterURL + filter , {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get sorter config list"));
        });
    }

    deleteSorterConfig(prio: number) {
        let filter: string = '/deleteSorterConfig' + '?prio=' + prio;
        return this.http.delete(this.sorterURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not delete sorter config item"));
        });
    }

    getSorterConfig(prio: number) {
        let filter: string = '/sorterConfig' + '?prio=' + prio;
        return this.http.get(this.sorterURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get sorter config item"));
        });
    }

    updateOrCreateSorterConfig(prio: number, channel: string, projectId: number, routingInformation: string, storageStatus: string){
        let filter: string = '/updateOrCreateSorterConfig' + '?prio=' + prio + '&channel=' + channel;
        if (projectId != null){filter += '&projectId=' + projectId}
        if (routingInformation != null){filter += '&routingInformation=' + routingInformation}
        if (storageStatus != null){filter += '&storageStatus=' + storageStatus}
        return this.http.put(this.sorterURL + filter, {}, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return {};
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not update/create Sorter Config"));
        });  
    }


    getContainerNameParcels(containerName: string) {
        let filter: string = '?containerName=' + containerName + '&storageName=' + this.authenticationService.getStorageName();
        return this.http.get(this.storageURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get parcels in the container"));
        });
    }

    getParcel(parcelCode: string) { // this can return more than one order in case of GAS (order sent in separate packages, more than 1 hawb)
        let filter: string = parcelCode;
        return this.http.get(this.storageURL + "/" + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get parcel"));
        });
    }

    getParcelByTrackingNumber(parcelCode: string) {
        let filter: string = '/tracking/' + parcelCode;
        return this.http.get(this.storageURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get parcel"));
        });
    }

    // connect directly to reader service
    getDetailsByBusinessKeyReader(businessKey: string) {
        let filter: string = '/order/businessKey/' + businessKey + '?getConsignee=true';
        return this.http.get(this.readerURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            //return Observable.throw(new Error("Could not get order details"));
            console.log('ERROR order details not found!');
            return null;
        });
    }

    getRelatedOrdersByBusinessKeyReader(businessKey: string) {
        let filter: string = '/orders/businessKey/' + businessKey;
        return this.http.get(this.readerURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("ERROR related orders not found!"));
        });
    }


    getTrackingsByBusinessKey(businessKey: string) {
        let filter: string = '/order/trackings/businessKey/' + businessKey;
        return this.http.get(this.readerURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.text();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get order details"));
            //console.log('ERROR trackings not found!');
            //return null;
        });
    }



    updateStorageByBusinesskey(storage: any, eventType: string, initReference: string) {
        this.authenticationService.getUserName().subscribe(message => { this.userName = message; });
        let filter: string = '?eventType=' + eventType + '&initReference=' + initReference;
        let storageRest = {
          itemCount: storage.itemCount,
          containerName: storage.containerName,
          containerStorage: this.authenticationService.getStorageName(),
          reference: storage.reference,
          storeUser: this.userName,
          storeDate: new Date(),
          businessKey: storage.businessKey,
          projectId: storage.projectId,
          workflowStatus: storage.workflowStatus || null
        }
        return this.http.put(this.storageURL + '/businessKey/' + storage.businessKey + filter, storageRest, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not update storage by businesskey"));
        });  
    }

    updateStorage(storage: any, eventType: string) {
        let filter: string = '/' + storage.reference + '?eventType=' + eventType;
        this.authenticationService.getUserName().subscribe(message => { this.userName = message; });
        let storageRest = {
          itemCount: storage.itemCount,
          containerName: storage.containerName,
          containerStorage: this.authenticationService.getStorageName(),
          reference: storage.reference,
          storeUser: this.userName,
          storeDate: new Date(),
          businessKey: storage.businessKey,
          projectId: storage.projectId
        }
        return this.http.put(this.storageURL + filter, storageRest, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not update storage"));
        });  
    }

    createStorage(storage: any) {
        this.authenticationService.getUserName().subscribe(message => { this.userName = message; });
        
        storage.storeUser = this.userName;
        storage.storeDate = new Date();
        storage.containerStorage = this.authenticationService.getStorageName();
          
        return this.http.post(this.storageURL, storage, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not create storage"));
        });  
    }

    deleteContainer(container: any) {
        container.containerStatus = 'DELETED';
        return this.updateContainer(container, true);
    }

    updateContainer(container: any, update: boolean) {
        let filter: string = '?update=' + update;
        container.storage = this.authenticationService.getStorageName();
        return this.http.put(this.containerURL + filter, container, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch(err => this.handleError(err));

    }

    private handleError (error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            try {
                errMsg = error.json();
            } catch (e) {
                // No content response..
                errMsg = null;
            }
        }
        return Observable.throw(errMsg);
    }

    getContainers(containerType: string) {
        let filter: string = '?containerType=' + containerType + '&storageName=' + this.authenticationService.getStorageName()
        return this.http.get(this.containerURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get containers"));
        });
    }

    getContainer(containerName: string) {
        return this.http.get(this.containerURL + "/" + containerName + '?storageName=' + this.authenticationService.getStorageName(), {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get container!"));
        });
    }

    getContainerLabel(containerName: string) {
        return this.http.get(this.containerURL + '/label/' + containerName + '?storageName=' + this.authenticationService.getStorageName(), 
            {
                headers: this.authenticationService.getHeaderPDF(),
                responseType: ResponseContentType.Blob
            })
           .map((res: Response) => {
                let fileBlob = res.blob();
                let blob = new Blob([fileBlob], { 
                    type: 'application/pdf' // must match the Accept type
                });
                let filename = containerName+'.pdf';
                FileSaver.saveAs(blob, filename); 
                return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get container label"));
        });
    }

    sendToException(exception: any) {
        exception.containerStorage = this.authenticationService.getStorageName();
        return this.http.put(this.exceptionURL, exception, { // thorws an error if the parcel already has an exception!!
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not set exception"));
        });
    }

    getExceptions(exceptionStatus: string) {
        let filter: string = '/' + exceptionStatus;
        return this.http.get(this.exceptionURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get exceptions"));
        });
    }

    resolveException(code: string, exceptionStatus: string) {
        let filter: string = '/resolve/' + code;
        if (exceptionStatus) {
            filter = filter + '?exceptionStatus=' + exceptionStatus;
        }
        return this.http.put(this.exceptionURL + filter, '', {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            if (error.status == '404') { // exception may not exist
                return of({});
            } else {        
                return Observable.throw(new Error("Could not resolve exception"));
            }            
        });

    }

    getException(exceptionCode: string) {
        let filter: string = '/code/' + exceptionCode;
        return this.http.get(this.exceptionURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get exception"));
        });
    }

    getExceptionsByCodes(exceptionCodes: string[]) {
        let filter: string = '/get/all/code';
        return this.http.post(this.exceptionURL + filter, exceptionCodes, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get exceptions by code"));
        });
    }

    resolveExceptionsBulk(exceptionCodeRequests: any[]) {
        let filter: string = '/resolve/bulk/all';
        return this.http.put(this.exceptionURL + filter, exceptionCodeRequests, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not resolve exceptions in bulk"));
        });
    }

    getLineHauls() {
        let filter: string = 'lineHauls';
        return this.http.get(this.containerURL + "/" + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get line hauls"));
        });
    }

    getLineHaulByNameAndWorkflow(name: string, workflow: string) {

        name = this.encodeAmpersand(name);

        let filter: string = 'lineHaul?name=' + name + '&workflow=' + workflow;
        return this.http.get(this.containerURL + "/" + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return  res.text() ? res.json() : '';
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get line haul!"));
        });
    }

    private encodeAmpersand(name: string) : string {
        if (name.includes("&")) {
            name = name.replace(/&/g, "%26");
        }
        return name
    }

    getStorages(token: string) {
        var headers = this.injector.get(AuthenticationService).getHeaderByToken(token);

        return this.http.get(this.containerURL + '/storages', {
            headers: headers
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {

            return Observable.throw(new Error("Could not get storages"));
        });
    }

    getResolvedExceptions(exceptionType: string) {
        let filter: string = exceptionType;
        return this.http.get(this.exceptionURL + '/resolved/exceptionType/' + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get resolved exceptions"));
        });
    }

    getStorageStatus(trackingNumber: any) {
    
        return this.http.get(this.storageURL + '/status/' + trackingNumber, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get storage status"));
        });
    }

    calculateStorageStatus(orderBusinessKey: any, trackingNumber: any) {
    
        return this.http.put(this.storageURL + '/status/' + orderBusinessKey + '/' + trackingNumber, '', {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not calculate storage status"));
        });
    }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/services/storage.service.ts